import collectionDefaults from '@shared/js/types/collection.js'
import { cleanHTMLEntities } from '@helpers/utils.js'
import { PLACEHOLDER_CARD_IMAGE } from '@config'
import Serializer, {
  extractCardImage,
} from '@shared/js/serializers/Serializer.js'

const transformations = [
  _addGameNameId,
  _clean,
  extractCardImage(PLACEHOLDER_CARD_IMAGE, true),
]

const collectionSerializer = new Serializer({
  transformations,
  defaults: collectionDefaults,
})

function _addGameNameId(collection) {
  if (!collection.game_name_id) {
    collection.game_name_id =
      collection.url?.match(/(\/g\/)([\w-]+)/)?.[2] || ''
  }
  return collection
}

function _clean(collection) {
  collection.name = collection.name ? cleanHTMLEntities(collection.name) : ''
  collection.summary = collection.summary
    ? cleanHTMLEntities(collection.summary)
    : ''
  return collection
}

export default collectionSerializer
